<template>
  <b-col
    sm="12"
  >
    <b-card>
      <b-row>
        <b-col sm="12">
          <h3 style="font-weight: bolder;font-size: 23px;">
            SEGUIMIENTO AL PLAN REGIONAL DE COMPETITIVIDAD Y PRODUCTIVIDAD DE SAN MARTÍN AL 2030</h3>
        </b-col>
        <!-- <b-col
          sm="2"
          style="text-align: right;"
        >
          <b-form-select
            v-model="selected"
            :options="optionsPeriodo"
            @change="onChangePeriodo($event)"
          />
        </b-col> -->
      </b-row>
    </b-card>
    <b-row>
      <b-col
        sm
        style="text-cente"
        class="match-height"
      >
        <b-card>
          <b-card-header
            class="centrate"
            style="padding: 0.1rem;"
          >
            <b-card-title style="font-weight: bolder;font-size: 20px;">
              RESUMEN GENERAL</b-card-title>
            <!-- <feather-icon
              icon="MoreVerticalIcon"
              size="18"
              class="cursor-pointer"
            /> -->
          </b-card-header>
          <b-card-group style="max-height:8rem;">
            <b-card
              class="text-center"
              @click="goObjetivos()"
            >
              <h4 class="mb-25 font-weight-bolder">
                OBJETIVOS
              </h4>
              <div
                class="d-flex between align-items-center"
                style="margin-left: 1vh;"
              >
                <b-avatar
                  class="ml-2 mt-1"
                  variant="light-danger"
                  size="55"
                >
                  <feather-icon
                    size="30"
                    icon="BriefcaseIcon"
                  />
                </b-avatar>
                <div class="ml-2 mt-2">
                  <span
                    class="font-weight-bolder"
                    style="font-size:35px"
                  >{{ totalObjetivo }}</span>
                </div>
              </div>
            </b-card>
            <b-card class="centrate">
              <h4 class="mb-25 font-weight-bolder">
                MEDIDAS
              </h4>
              <div
                class="d-flex between align-items-center"
                style="margin-left: 1vh;"
              >
                <b-avatar
                  class="ml-1 mt-1"
                  variant="light-info"
                  size="55"
                >
                  <feather-icon
                    size="30"
                    icon="ThermometerIcon"
                  />
                </b-avatar>
                <div class="ml-1 mt-1">
                  <span
                    class="font-weight-bolder"
                    style="font-size:35px"
                  >{{ totalMedida }}</span>
                </div>
              </div>
            </b-card>
            <b-card class="text-center">
              <h4 class="mb-25 font-weight-bolder">
                HITOS
              </h4>
              <div
                class="d-flex between align-items-center"
                style="margin-left: 1vh;"
              >
                <b-avatar
                  class="ml-2 mt-1"
                  variant="light-success"
                  size="55"
                >
                  <feather-icon
                    size="30"
                    icon="BookOpenIcon"
                  />
                </b-avatar>
                <div class="ml-1 mt-1">
                  <span
                    class="font-weight-bolder"
                    style="font-size:35px"
                  >{{ totalHito }}</span>
                </div>
              </div>
            </b-card>
          </b-card-group>
          <b-card-group style="max-height:10rem;">
            <!-- <b-card class="text-center">
              <h3 class="mb-25 font-weight-bolder">
                INDICADORES
              </h3>
              <div
                class="d-flex between align-items-center"
                style="margin-left: 20px;"
              >
                <b-avatar
                  class="ml-5 mt-1"
                  variant="light-warning"
                  size="55"
                >
                  <feather-icon
                    size="30"
                    icon="TrendingUpIcon"
                  />
                </b-avatar>
                <div class="ml-3">
                  <span
                    class="font-weight-bolder"
                    style="font-size:35px"
                  >{{ totalIndicador }}</span>
                </div>
              </div>
            </b-card> -->
          </b-card-group>
        </b-card>
        <b-card>
          <b-row>
            <b-col
              sm="3"
              style="text-align: right;;margin-top: 0.5vh"
            >
              <h6>AÑOS</h6>
            </b-col>
            <b-col
              sm="3"
            >
              <b-form-select
                v-model="anioSelected"
                :options="optionsAnios"
                size="sm"
                @input="changeAnio"
              />
            </b-col>
            <b-col
              sm="3"
            >
              <h5>FILTRO ACUMULADO</h5>
            </b-col>
            <b-col
              sm="3"
            >
              <b-form-checkbox
                v-model="filterAcumulado"
                @input="changeFiltAcumulado"
              />
            </b-col>
          </b-row>
        </b-card>
        <b-card-group>
          <b-card class="align-items-center">
            <b-card-header>
              <b-card-title style="font-weight: bolder;font-size: 20px;position: relative;left: 10vh;">
                AVANCE GENERAL</b-card-title>
            </b-card-header>
            <b-row>
              <b-col
                id="chart"
                sm="6"
              >
                <div
                  v-if="loadingAnio"
                  style="inset: 0px;z-index: 10;inset: 0px;opacity: 0.85;backdrop-filter: blur(2px);background-color: #f6f6f6;position: absolute !important;width: 47.5vh;"
                />
                <div
                  id="divGrafico4"
                />
                <!-- style="left: 27vh;position: relative" -->
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-card-header>
              <b-card-title style="font-weight: bolder;font-size: 20px;position: relative;left: 10vh;">
                AVANCE DEL {{ year=='-1'?'2030':year }}</b-card-title>
            </b-card-header>
            <b-row>
              <b-col
                sm="6"
              >
                <div
                  v-if="loadingAnio"
                  style="inset: 0px;z-index: 10;inset: 0px;opacity: 0.85;backdrop-filter: blur(2px);background-color: #f6f6f6;position: absolute !important;width: 47.5vh;"
                />
                <div
                  id="divGrafico2"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col
        sm="6"
      >
        <b-card
          no-body
        >
          <b-card-header class="centrate">
            <b-card-title style="font-weight: bolder;font-size: 20px;">
              AVANCE POR OBJETIVO PRIORITARIO DEL {{ year=='-1'?'2030':year }}</b-card-title>
          </b-card-header>
          <!-- body -->
          <b-card-body>
            <div
              v-for="(objetivo,index) in items.avanceObjetivo"
              :key="objetivo.tipoObjetivoId"
              :class="`pl-2 mt-1  border-left-op${index+1} border-left-3`"
              style="margin-top: 0.5rem !important;"
              @click="ObjetivoDetalle(objetivo.tipoObjetivoId)"
            >
              <b-row>
                <b-col
                  md="2"
                  class="centrate"
                >
                  <b-img
                    style="width:70px;height:70px;"
                    :src="require(`@/assets/images/prcp/op${index+1}.png`)"
                  />
                </b-col>
                <b-col
                  md="8"
                  class="align-items-center"
                >
                  <h5>
                    <strong style="font-size: 18px;">{{ objetivo.descripcion }} </strong>
                  </h5>
                  <small style="font-size: 15px;">{{ objetivo.representante.conductor.descripcion }}</small>
                </b-col>
                <b-col
                  md="2"
                  class="centrate"
                >
                  <vue-apex-charts
                    v-if="!loadingAnio"
                    type="radialBar"
                    height="70"
                    width="60"
                    :options="chartData[index].options"
                    :series="chartData[index].series"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import {
  BRow, BCol, BCard, BCardTitle, BCardHeader, BCardBody, BAvatar, BCardGroup, BImg, BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'
// BFormSelect,
import store from '@/store'
import VueApexCharts from 'vue-apexcharts'
import ApexCharts from 'apexcharts'
import { $themeColors } from '@themeConfig'
import moment from 'moment'
/* eslint-disable global-require */
const $trackBgColor = '#e9ecef'
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BCardHeader,
    BCardBody,
    BAvatar,
    BCardGroup,
    VueApexCharts,
    BImg,
    BFormSelect,
    // BFormSelect,
    BFormCheckbox,
  },
  data() {
    return {
      totalObjetivo: 0,
      totalEntidad: 0,
      totalMedida: 0,
      loadingAnio: false,
      chartGeneral: null,
      totalHito: 0,
      totalIndicador: 0,
      avance: 0,
      pendiente: 0,
      avance2021: 0,
      pendiente2021: 0,
      dataPie: [],
      items: [],
      objetivos: [],
      chtClassReport1: null,
      year: moment(new Date()).locale('es').format('YYYY'),
      chartOptionsReport1: {
        series: [],
        chart: {
          width: 450,
          type: 'pie',
          events: {},
        },
        labels: [],
        responsive: [{
          breakpoint: 100,
          options: {
            chart: {
              width: 100,
            },
            legend: {
              position: 'bottom',
              floating: false,
              fontSize: '1vh',
              fontFamily: 'Helvetica, Arial',
              fontWeight: 400,
            },
          },
        }],
        dataLabels: {
          enabled: true,
          formatter: val => `${val}%`,
          style: {
            fontSize: '18px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
          },
        },
      },
      chartOptionsReportAnio: {
        series: [],
        chart: {
          width: 450,
          type: 'pie',
          events: {},
        },
        labels: [],
        responsive: [{
          breakpoint: 100,
          options: {
            chart: {
              width: 150,
            },
            legend: {
              position: 'bottom',
              floating: false,
              fontSize: '1vh',
              fontFamily: 'Helvetica, Arial',
              fontWeight: 400,
            },
          },
        }],
        dataLabels: {
          enabled: true,
          formatter: val => `${parseInt(val, 0)}%`,
          style: {
            fontSize: '18px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
          },
        },
      },
      anioRepo: [moment(new Date()).locale('es').format('YYYY')],
      modalShow: false,
      titleModal: 'Detalle',
      isBusyModal: false,
      typeAction: 'show',
      chartData: [],
      chartClone: {},
      chartColor: ['#8F5AA0', '#EABA18', '#63BCA6', '#5DB5E5', '#1D924C', '#E84462', '#6463A9', '#E96978', '#F08149'],
      direcciones: ['Sub Gerencia de Programacion Multianual de Investigacion', 'Gerencia Regional de Desarrollo Social', 'Gerencia Regional de Desarrollo Economico', 'Direccion Regional de la Produccion', 'Direccion Regional de Trabajo y Promocion del Empleo', 'Oficina de Promocion de la Investigasion Privada Sostenible', 'Direccion Regional de Comercio Exterios y Turismo', 'Sub Gerencia de Desarrollo Institucional', 'Autoridad Regional Ambiental'],
      chart: {
        series: [65],
        options: {
          grid: {
            show: false,
            padding: {
              left: -15,
              right: -15,
              top: -12,
              bottom: -15,
            },
          },
          colors: [$themeColors.primary],
          plotOptions: {
            radialBar: {
              hollow: {
                size: '40%',
              },
              track: {
                background: $trackBgColor,
              },
              dataLabels: {
                showOn: 'always',
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  offsetY: 3,
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return `${(val).toFixed(2)}%`
                  },
                },
              },
              tooltip: {
                y: {
                  formatter: val => `${val.toFixed(2)} %`,
                },
              },
            },
          },
          stroke: {
            lineCap: 'round',
          },
        },
      },
      selected: null,
      selectedId: 0,
      anioSelected: moment(new Date()).locale('es').format('YYYY'),
      optionsPeriodo: [
      ],
      optionsAnios: [
      ],
      chartAnio: null,
      tipoFiltro: '1',
      filterAcumulado: false,
    }
  },
  async mounted() {
    await this.listPeriodo()
  },
  methods: {
    ObjetivoDetalle(idMedida) {
      this.$router.push({ name: 'objetivo-detalle', params: { id: idMedida } })
    },
    showModalDetail() {
      this.titleModal = 'Detalle de Indicador'
      this.modalShow = true
    },
    okMdl(ev) {
      ev.preventDefault()
    },
    changeAnio(data) {
      this.anioSelected = data
      // this.chtClassReport1 = null
      this.year = data
      console.log('this.filterAcumulado', this.filterAcumulado)
      if (this.filterAcumulado) {
        this.tipoFiltro = '2'
        if (this.selectedAnio !== '-1') {
          this.listaObjetivos()
        }
      } else {
        this.tipoFiltro = '1'
        this.listaObjetivos()
      }
    },
    changeFiltAcumulado() {
      if (this.filterAcumulado) {
        this.tipoFiltro = '2'
        if (this.selectedAnio !== '-1') {
          this.listaObjetivos()
        }
      } else {
        this.tipoFiltro = '1'
        this.listaObjetivos()
      }
    },
    async listaObjetivos() {
      this.chartData = []
      this.loadingAnio = true
      this.avance = 0
      this.pendiente = 0
      this.avance2021 = 0
      this.pendiente2021 = 0
      await store.dispatch('gsseguimiento/REPORTE_PRINCIPAL', { periodo: this.selectedId, anio: this.year, tipoFiltro: this.tipoFiltro })
        .then(response => {
          this.items = response
          this.avance = response.avance
          this.pendiente = response.pendiente
          this.avance2021 = response.avance2021
          this.pendiente2021 = response.pendiente2021
          if (this.year === '2030' || this.year === '-1') {
            this.avance2021 = response.avance
            this.pendiente2021 = response.pendiente
          }

          if ((this.year === '2030' || this.year === '-1') && this.tipoFiltro === '2') {
            this.avance2021 = response.avance
            this.pendiente2021 = response.pendiente
          }
          this.totalObjetivo = response.objetivos
          this.totalMedida = response.medidas
          this.totalHito = response.hitos
          this.totalIndicador = response.indicadores
          for (let i = 0; i < response.avanceObjetivo.length; i += 1) {
            const chartClone = JSON.parse(JSON.stringify(this.chart))
            chartClone.options.colors[0] = this.chartColor[i]
            chartClone.series[0] = response.avanceObjetivo[i].avance
            this.chartData.push(chartClone)
          }
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
      await this.loadReportanio()
      await this.loadReport1()
      this.loadingAnio = false
    },
    loadReportanio() {
      if (this.loadingAnio) {
        this.chartAnio = null
        this.chartOptionsReportAnio.series = []
        this.chartOptionsReportAnio.labels = []
        document.querySelector('#divGrafico2').innerHTML = ''
      }
      const data = [
        { id: 1, total: this.avance2021, descripcion: 'Avance' },
        { id: 2, total: this.pendiente2021, descripcion: 'Pendiente' },
      ]
      const r1 = []
      const r2 = []
      data.forEach(dat => {
        r1.push(dat.total)
        r2.push(dat.descripcion)
      })
      const chartClone = JSON.parse(JSON.stringify(this.chartOptionsReportAnio))
      chartClone.series = r1
      chartClone.labels = r2
      chartClone.colors = ['#148A4D', '#0F5396']
      this.chartAnio = new ApexCharts(document.querySelector('#divGrafico2'), chartClone)
      this.chartAnio.render()
    },
    async loadReport1() {
      if (!this.loadingAnio) {
        this.chartGeneral = null
        document.querySelector('#divGrafico4').innerHTML = ''
      }
      const data = [
        { id: 1, total: this.avance, descripcion: 'Avance' },
        { id: 2, total: this.pendiente, descripcion: 'Pendiente' },
      ]
      const r1 = []
      const r2 = []
      data.forEach(dat => {
        r1.push(dat.total)
        r2.push(dat.descripcion)
      })
      this.chartOptionsReport1.series = r1
      this.chartOptionsReport1.labels = r2
      this.chartOptionsReport1.colors = ['#148A4D', '#0F5396']
      this.chartGeneral = new ApexCharts(document.querySelector('#divGrafico4'), this.chartOptionsReport1)
      this.chartGeneral.render()
    },
    goObjetivos() {
      this.$router.push({ name: 'list-objetivo' })
    },
    async listPeriodo() {
      await store.dispatch('gsseguimiento/PERIODO_ALL_FIND', { periodo: -1 })
        .then(response => {
          //  { value: null, text: 'PERIODO' }
          for (let i = 0; i < response.length; i += 1) {
            this.optionsPeriodo.push({ value: response[i].periodoId, text: response[i].descripcion })
          }
          this.selected = response[response.length - 1].periodoId
          this.selectedId = response[response.length - 1].periodoId
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
      await this.listAniosAll()
      await this.listaObjetivos()
    },
    async listAniosAll() {
      store.dispatch('gsseguimiento/ANIO_PERIODO_ALL', { periodo: this.selectedId })
        .then(response => {
          this.optionsAnios.push({ value: '-1', text: 'TODOS' })
          response.forEach(element => {
            this.optionsAnios.push({ value: element, text: element })
          })
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    onChangePeriodo(event) {
      this.selectedId = event
      this.listaObjetivos()
    },
  },
  showError(error) {
    let errorMessage = 'Intentelo en otro momento.'
    if (error.response) {
      errorMessage = error.response.data.errorMessage
    }
    this.$bvToast.toast(errorMessage, {
      title: 'Ha ocurrido un error',
      variant: 'danger',
      solid: true,
    })
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
.op1 {
  color: #8F5AA0;
}
.op2 {
  color: #EABA18;
}
.op3 {
  color: #63BCA6;
}
.op4 {
  color: #5DB5E5;
}
.op5 {
  color: #1D924C;
}
.op6 {
  color: #E84462;
}
.op7 {
  color: #6463A9;
}
.op8 {
  color: #E96978;
}
.op9 {
  color: #F08149;
}

.border-left-op1 {
  border-left: 1px solid #8F5AA0;
}
.border-left-op2 {
   border-left: 1px solid #EABA18;
}
.border-left-op3 {
  border-left: 1px solid #63BCA6;
}
.border-left-op4 {
   border-left: 1px solid #5DB5E5;
}
.border-left-op5 {
   border-left: 1px solid #1D924C;
}
.border-left-op6 {
   border-left: 1px solid #E84462;
}
.border-left-op7 {
   border-left: 1px solid #6463A9;
}
.border-left-op8 {
   border-left: 1px solid #E96978;
}
.border-left-op9 {
   border-left: 1px solid #F08149;
}

.centrate{
  text-align: center;
}

.card-body{
      padding: 1.3rem;
}

</style>
